import { render, staticRenderFns } from "./matter.vue?vue&type=template&id=f88ac70e&scoped=true&"
import script from "./matter.vue?vue&type=script&lang=js&"
export * from "./matter.vue?vue&type=script&lang=js&"
import style0 from "./matter.vue?vue&type=style&index=0&id=f88ac70e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88ac70e",
  null
  
)

export default component.exports